// extracted by mini-css-extract-plugin
export default {"addFood":"AddFood_addFood__5YjOd","slideIn":"AddFood_slideIn__OxWXj"};